<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-input placeholder="ID/会员名/手机号码" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="升级时间">
      <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        prop="username"
        label="会员名"
        >
      </el-table-column>
      <el-table-column
      label="升级类型">
      <template slot-scope="scope"> 
        <el-tag type="info">{{scope.row.leveltype}}</el-tag>  
      </template>
      </el-table-column>
      <el-table-column
        prop="oldlevelname"
        label="原级别">
      </el-table-column>
      <el-table-column
        prop="newlevelname"
        label="新级别">
      </el-table-column>
      
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        }
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/user/getUserLevelList",{pageinfo:this.pageinfo,keywords:this.keywords}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.list
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      }
  }
}
</script>

<style scoped lang="scss">
.order-detail {font-size:14px;}
.order-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
</style>
